import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../app/store';
import { setOrientation } from './napkinSlice';
import ProductDisplay from './ProductDisplay';
import FanOutOptions from './FanOutOptions';
import SummaryView from './SummaryView';
import './CustomizeInterface.css';

const CustomizeInterface: React.FC = () => {
  const dispatch = useDispatch();
  const napkinState = useSelector((state: RootState) => state.napkin);
  
  const [activeModal, setActiveModal] = useState<'napkin' | 'quantity' | 'text' | 'image' | null>(null);

  const openModal = (modalType: 'napkin' | 'quantity' | 'text' | 'image') => {
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  // Transform napkin state to summary data format
  const summaryData = {
    quantity: napkinState.quantity,
    napkinColor: napkinState.color,
    colorText: napkinState.foilColor,
    line1: napkinState.textLineOne,
    line2: napkinState.textLineTwo,
    font: napkinState.font,
    image: napkinState.image
  };

  return (
    <div className="customize-interface">
      {/* Control Buttons */}
      <div className="option-controls">
        <div className="control-buttons">
          <button 
            type="button" 
            className="btn btn-primary btn-lg" 
            onClick={() => openModal('napkin')}
            style={{ background: '#28a745' }}
          >
            napkin
          </button>
          <button 
            type="button" 
            className="btn btn-primary btn-lg" 
            onClick={() => openModal('quantity')}
            style={{ background: '#17a2b8' }}
          >
            quantity
          </button>
          <button 
            type="button" 
            className="btn btn-primary btn-lg" 
            onClick={() => dispatch(setOrientation(napkinState.orientation === 'square' ? 'diamond' : 'square'))}
            style={{ 
              background: '#ffc107', 
              color: '#333',
              position: 'relative',
              padding: '8px 24px',
              minWidth: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden'
            }}
            title={`Currently: ${napkinState.orientation}. Click to rotate napkin.`}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '28px',
              lineHeight: '1',
              transition: 'transform 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              transform: napkinState.orientation === 'diamond' ? 'rotate(405deg)' : 'rotate(0deg)',
              width: '28px',
              height: '28px'
            }}>
              ↻
            </div>
          </button>
          <button 
            type="button" 
            className="btn btn-primary btn-lg" 
            onClick={() => openModal('text')}
            style={{ background: '#9c27b0' }}
          >
            text
          </button>
          <button 
            type="button" 
            className="btn btn-primary btn-lg" 
            onClick={() => openModal('image')}
            style={{ background: '#ff5722' }}
          >
            image
          </button>
        </div>
      </div>

      {/* Product Display */}
      <ProductDisplay />

      {/* Summary View */}
      <SummaryView data={summaryData} />

      {/* Fan Out Options */}
      <FanOutOptions activeOption={activeModal} onClose={closeModal} />
    </div>
  );
};

export default CustomizeInterface;
